// Autogenerated by script
import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

export const Burger: typeof SvgIcon & { activeColor: string } = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="M3.36 3.01h17.31c.735 0 1.33.595 1.33 1.33v1.34a1.33 1.33 0 0 1-1.33 1.33H3.36a1.33 1.33 0 0 1-1.33-1.33V4.34c0-.735.595-1.33 1.33-1.33ZM3.36 10h17.31c.735 0 1.33.595 1.33 1.33v1.34A1.33 1.33 0 0 1 20.67 14H3.36a1.33 1.33 0 0 1-1.33-1.33v-1.34c0-.735.595-1.33 1.33-1.33ZM3.36 17.01h17.31c.735 0 1.33.595 1.33 1.33v1.34a1.33 1.33 0 0 1-1.33 1.33H3.36a1.33 1.33 0 0 1-1.33-1.33v-1.34c0-.735.595-1.33 1.33-1.33Z" />
  </SvgIcon>
);

Burger.activeColor = 'inherit';
Burger.muiName = 'Burger';
